export enum PSTFieldNames {
    PSTTopicSlug = "Title",
    PSTTopicSummary = "Description",
    PSTApproved = "PSTApproved",
    PSTTopicDepartment = "PSTGroup",
    PSTTopicCategory = "PSTCategory",
    PSTTopicFileDate = "PSTTargetDate",
    PSTTopicNotes = "PSTTopicNotes",
    PSTTopicStoryOwner = "PSTTopicOwner",
    PSTTopicStatus = "PSTTopicStatus",
    PSTTopicType = "PSTTopicType",
    PSTTopicEventStartDate = "EventStart",
    PSTTopicEventEndDate = "EventEnd",
    PSTTopicSource = "APSource",
    PSTTopicTag = "Tags",
    Owner = "Owner",
    Type = "Type",
    PSTCreatedBy = "CreatedBy",
    PSTExternalFiles = "ExternalFiles",
    PSTModTime = "ModTime",
    PSTAssignmentModTime = "ModTime",
    PSTTeamLocation = "PSTTeamLocation",

    PSTAssignmentOwner = "PSTAssignmentOwner",
    PSTAssignmentFileDate = "PSTTargetDate",
    PSTAssignmentNewsEditor = "APNewsEditor",
    PSTAssignmentSlug = "Title",
    PSTAssignmentPublishingDesk = "PSTGroup",
    PSTAssignmentCoverageType = "PSTCoverageType",
    PSTAssignmentCost = "PSTCost",
    PSTAssignmentStatus = "PSTAssignmentStatus",
    PSTAssignmentCoverage = "Description",
    PSTAssignmentRole = "Editorial Team",
    PSTParentCategory = "ParentCategory",
    PSTParentLocation = "ParentLocation",
    PSTParentOwner = "ParentOwner",
    PSTParentType = "ParentType",

    UserInfoID = "UserID",
    UserInfoProgram = "Program",
    UserInfoGivenName = "GivenName",
    UserInfoSurname = "Surname",
    UserInfoEmail = "Email",
    UserInfoSSOLogins = "SSOLogins",
    UserInfoStatus = "InvitationStatus",
    UserInfoRole = "GlobalRole",
    UserInfoActive = "Active",

    RSLocation = "RSLocation",
    PSTTopicAddress = "PSTTopicAddress",

    PSTViewStateType = "PSTViewStateType",
    PSTViewStateFilter = "PSTViewStateFilter",
    PSTViewStateGrouping = "PSTViewStateGrouping",
    PSTViewStateSorting = "PSTViewStateSorting",
    PSTViewStateSortOrder = "PSTViewStateSortOrder",
    PSTViewStateGroupSortOrder = "PSTViewStateGroupSortOrder",
    PSTViewStateLayout = "PSTViewStateLayout",
    PSTViewStateSearchQuery = "PSTViewStateSearchQuery",
    PSTViewStateSlideshowDelay = "PSTViewStateSlideshowDelay",
    PSTViewStateSlideshowSequence = "PSTViewStateSlideshowSequence",
    PSTViewStateCardCustomItems = "PSTViewStateTopicCardCustomItems",
    PSTViewStateFeedID = "PSTViewStateFeedID",
    PSTViewStateFeedURL = "PSTViewStateFeedURL",
    PSTViewStateTwitterFeedName = "PSTViewStateTwitterFeedName",

    PSTRichText = "text",

    PSTWireTitle = "Title",
    PSTWireText = "text",
    PSTWireProvider = "WireProvider",
    PSTWirePriority = "Priority",
    PSTWireOwner = "Owner",
    PSTWireCategory = "WireCategory",
    PSTWirePublished = "Published",
    PSTWireSubjectXML = "SubjectXML",
    PSTWireImage = "Image",
    PSTWireVideo = "Video",
    PSTWireTag = "Tags",
    PSTLinkedRecords = "LinkedRecords",

    PSTRundownStartTime = "StartTime",
    PSTRundownSequence = "Sequence",
    PSTDraftTitle = "Title",
    PSTChannel = "PSTChannel",
    PSTDraftText = "Text",
    PSTStoryLocked = "Locked",

    PSTPublicationApproved = "PSTPublicationApproved",
    PSTPublicationTime = "PSTPublicationListTime",
    PSTPublicationSequenceCollection = "PublicationSequenceCollection",
    PSTPublicationListPublishedTime = "PSTPublicationListPublishedTime",
    PSTPublicationListPublishedBy = "PSTPublicationListPublishedBy",
    PSTPublicationListRevisionNumber = "PSTPublicationListRevisionNumber",
    PSTPublicationStatus = "PSTPublicationListStatus",
    PSTPublicationChannelTimeRange = "PSTPublicationChannelTimeRange",
    PSTPublicationChannelGUID = "PSTPublicationChannelGUID",

    PSTPublicationChannelName = "Title",
    PSTPublicationChannelType = "PSTPublicationChannelType",
    PSTPublicationChannelSchedule = "PSTPublicationChannelSchedule",
    PSTPublicationChannelSections = "PSTPublicationChannelSections",
    PSTPublicationChannelRevisions = "PSTPublicationChannelRevisions",
    PSTPublicationChannelActionID = "PSTPublicationChannelActionID",
    PSTPublicationListTitle = "PSTPublicationListTitle",
    PSTPublicationChannelEditionNames = "PSTPublicationChannelEditionNames",
    PSTPublicationListEditionName = "PSTPublicationEditionName",
    Relationships = "Relationships",
    PSTViewStateGUID = "PSTViewStateGUID",
    WireCategory = "WireCategory",
    WireProvider = "WireProvider",

    ContactName = "Name",
    ContactEmail = "Email",
    ContactJobTitle = "JobTitle",
    ContactPhone = "Phone",
    ContactWorkAddress = "Address",
    PSTTopicOrder = "PSTTopicOrder",
	PSTMediaPath = "MediaPath",
	ChannelImage = "ChannelImage",
	Creator = "Creator"
}
